export default __webpack_public_path__ + "static/media/Shot_26.00001.f5a6d933.png";